import PubSub from "underpub-js";
import slick from "slick-carousel";

var MediaCarousel = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-MediaCarousel',
  };

  $.extend(true, this.options, options);

};

MediaCarousel.prototype.init = function () {

  var self = this;
};

export default MediaCarousel;